import actions from "./actions";

const initState = {
    portinNetworkList: [],
    portinNetworkLoading: false,
    portinNetworkError: null,

    createPortinActivationLoading: false,
    createPortinActivationMessage: null,
    createPortinActivationError: null,

    bulkPortinActivationList: [],
    bulkPortinActivationLoading: false,
    bulkPortinActivationError: null,
    searchButtonLoading: false,

    checkSerialNumberLoading: false,
    checkSerialNumberResult: [],
    checkSerialNumberError: null,

    updateManualPortinActivationLoading: false,
    updateManualPortinActivationMessage: null,
    updateManualPortinActivationError: null,

    updatePortinStatusMessage: null,
    updatePortinStatusError: null,
    updatePortinStatusLoading: false,

    updatePortinActivatioBulkStatusMessage: null,
    updatePortinActivationBulkStatusError: null,
    updatePortinActivationBulkStatusLoading: false,

    bulkPortinActivationRequestResult: [],
    bulkPortinActivationRequestLoading: false,
    bulkPortinActivationRequestError: null,

    bulkPortinActivationResultByBatchID: [],
    bulkPortinActivationResultByBatchIDLoading: false,
    bulkPortinActivationResultByBatchIDError: null,

    openPortinModal: false,

    getPortinActivationsList: [],
    getPortinActivationsLoading: false,
    getPortinActivationsError: null,
    getPortinActivationsTotalRows: 0,
};

export default function reducer(state = initState, action) {
    switch (action.type) {

        case actions.GET_PORTIN_ACTIVATIONS:
            return {
                ...state,
                getPortinActivationsList: [],
                getPortinActivationsLoading: true,
                getPortinActivationsError: null,
                getPortinActivationsTotalRows: 0,
            };
        case actions.GET_PORTIN_ACTIVATIONS_SUCCESS:
            return {
                ...state,
                getPortinActivationsList: action.payload.data.Data,
                getPortinActivationsLoading: false,
                getPortinActivationsError: null,
                getPortinActivationsTotalRows: action.payload.data.TotalCount,
            };
        case actions.GET_PORTIN_ACTIVATIONS_FAILED:
            return {
                ...state,
                getPortinActivationsList: [],
                getPortinActivationsLoading: false,
                getPortinActivationsError: action.payload.error,
                getPortinActivationsTotalRows: 0,
            };


        case actions.OPEN_ADD_PORTIN_MODAL:
            return {
                ...state,
                openPortinModal: true,
            };
        case actions.CLOSE_ADD_PORTIN_MODAL:
            return {
                ...state,
                openPortinModal: false,
            };
        case actions.GET_BULK_PORTIN_ACTIVATION_LIST_BY_BATCHID:
            return {
                ...state,
                bulkPortinActivationResultByBatchID: [],
                bulkPortinActivationResultByBatchIDLoading: true,
                bulkPortinActivationResultByBatchIDError: null,
            };
        case actions.GET_BULK_PORTIN_ACTIVATION_LIST_BY_BATCHID_SUCCESS:
            return {
                ...state,
                bulkPortinActivationResultByBatchIDLoading: false,
                bulkPortinActivationResultByBatchID: action.result,
                bulkPortinActivationResultByBatchIDError: null,
            };
        case actions.GET_BULK_PORTIN_ACTIVATION_LIST_BY_BATCHID_FAILED:
            return {
                ...state,
                bulkPortinActivationResultByBatchIDLoading: false,
                bulkPortinActivationResultByBatchIDError: action.error,
            };
        case actions.GET_BULK_PORTIN_ACTIVATION_LIST:
            return {
                ...state,
                bulkPortinActivationRequestResult: [],
                bulkPortinActivationRequestLoading: true,
                bulkPortinActivationRequestError: null,
            };
        case actions.GET_BULK_PORTIN_ACTIVATION_LIST_SUCCESS:
            return {
                ...state,
                bulkPortinActivationRequestLoading: false,
                bulkPortinActivationRequestResult: action.result,
                bulkPortinActivationRequestError: null,
            };
        case actions.GET_BULK_PORTIN_ACTIVATION_LIST_FAILED:
            return {
                ...state,
                bulkPortinActivationRequestLoading: false,
                bulkPortinActivationRequestError: action.error,
            };
        case actions.GET_NETWORK_BY_DEALER_PORTIN_MAPPING:
            return {
                ...state,
                portinNetworkList: [],
                portinNetworkLoading: true,
                portinNetworkError: null,
            };
        case actions.GET_NETWORK_BY_DEALER_PORTIN_MAPPING_SUCCESS:
            return {
                ...state,
                portinNetworkLoading: false,
                portinNetworkList: action.result,
                portinNetworkError: null,
            };
        case actions.GET_NETWORK_BY_DEALER_PORTIN_MAPPING_FAILED:
            return {
                ...state,
                portinNetworkLoading: false,
                portinNetworkError: action.error,
            };

        case actions.CREATE_PORTIN_ACTIVATION:
            return {
                ...state,
                createPortinActivationLoading: true,
                createPortinActivationMessage: null,
                createPortinActivationError: null,
            };
        case actions.CREATE_PORTIN_ACTIVATION_SUCCESS:
            return {
                ...state,
                createPortinActivationLoading: false,
                bulkPortinActivationRequestResult: action.result,
                createPortinActivationMessage: action.message,
                createPortinActivationError: null,
                openPortinModal: false
            };
        case actions.CREATE_PORTIN_ACTIVATION_FAILED:
            return {
                ...state,
                createPortinActivationLoading: false,
                createPortinActivationError: action.error,
                createPortinActivationMessage: null,
            };

        case actions.GET_BULK_PORTIN_ACTIVATION:
            return {
                ...state,
                searchButtonLoading: true,
                bulkPortinActivationList: [],
                bulkPortinActivationLoading: true,
                bulkPortinActivationError: null,
            };
        case actions.GET_BULK_PORTIN_ACTIVATION_SUCCESS:
            return {
                ...state,
                searchButtonLoading: false,
                bulkPortinActivationLoading: false,
                bulkPortinActivationList: action.result,
                bulkPortinActivationError: null,
            };
        case actions.GET_BULK_PORTIN_ACTIVATION_FAILED:
            return {
                ...state,
                searchButtonLoading: false,
                bulkPortinActivationLoading: false,
                bulkPortinActivationError: action.error,
            };

        case actions.RESET_MESSAGES:
            return {
                ...state,
                createPortinActivationError: null,
                updateManualPortinActivationError: null,
                createPortinActivationMessage: null,
                checkSerialNumberResult: [],
            };
        case actions.RESET_DATA:
            return {
                ...state,
                portinActivationList: [],
                checkSerialNumberResult: [],
            };

        case actions.CHECK_SERIAL_NUMBER_BY_BATCH:
            return {
                ...state,
                checkSerialNumberLoading: true,
                checkSerialNumberResult: [],
                checkSerialNumberError: null,
            };
        case actions.CHECK_SERIAL_NUMBER_BY_BATCH_SUCCESS:
            return {
                ...state,
                checkSerialNumberLoading: false,
                checkSerialNumberResult: action.result,
                checkSerialNumberError: null,
            };
        case actions.CHECK_SERIAL_NUMBER_BY_BATCH_FAILED:
            return {
                ...state,
                checkSerialNumberLoading: false,
                checkSerialNumberError: action.error,
                checkSerialNumberResult: null,
            };

        case actions.UPDATE_MANUAL_PORTIN_ACTIVATION:
            return {
                ...state,
                updateManualPortinActivationLoading: true,
                updateManualPortinActivationMessage: null,
                updateManualPortinActivationError: null,
            };
        case actions.UPDATE_MANUAL_PORTIN_ACTIVATION_SUCCESS:
            return {
                ...state,
                updateManualPortinActivationLoading: false,
                updateManualPortinActivationMessage: action.message,
                updateManualPortinActivationError: null,
            };
        case actions.UPDATE_MANUAL_PORTIN_ACTIVATION_FAILED:
            return {
                ...state,
                updateManualPortinActivationLoading: false,
                updateManualPortinActivationError: action.error,
                updateManualPortinActivationMessage: null,
            };

        case actions.RESET_SUCCESS_MESSAGES:
            return {
                ...state,
                createPortinActivationMessage: null,
                updatePortinStatusMessage: null,
                updatePortinStatusError: null,
                updatePortinActivatioBulkStatusMessage: null,
                updatePortinActivationBulkStatusError: null,
                updateManualPortinActivationMessage: null,
            };

        case actions.UPDATE_PORTIN_STATUS:
            return {
                ...state,
                updatePortinStatusMessage: null,
                updatePortinStatusError: null,
                updatePortinStatusLoading: true,
            };
        case actions.UPDATE_PORTIN_STATUS_SUCCESS:
            return {
                ...state,
                updatePortinStatusError: null,
                updatePortinStatusMessage: action.message,
                updatePortinStatusLoading: false,
            };
        case actions.UPDATE_PORTIN_STATUS_FAILED:
            return {
                ...state,
                updatePortinStatusError: action.error,
                updatePortinStatusMessage: null,
                updatePortinStatusLoading: false,
            };

        case actions.UPDATE_PORTIN_ACTIVATION_BULK_STATUS:
            return {
                ...state,
                updatePortinActivatioBulkStatusMessage: null,
                updatePortinActivationBulkStatusError: null,
                updatePortinActivationBulkStatusLoading: true,
            };
        case actions.UPDATE_PORTIN_ACTIVATION_BULK_STATUS_SUCCESS:
            return {
                ...state,
                updatePortinActivationBulkStatusError: null,
                updatePortinActivatioBulkStatusMessage: action.message,
                updatePortinActivationBulkStatusLoading: false,
            };
        case actions.UPDATE_PORTIN_ACTIVATION_BULK_STATUS_FAILED:
            return {
                ...state,
                updatePortinActivationBulkStatusError: action.error,
                updatePortinActivatioBulkStatusMessage: null,
                updatePortinActivationBulkStatusLoading: false,
            };

        default:
            return state;
    }
}
